import { createSurveyStyles } from '@sm/webassets';

// TODO: RAWR-688 - add correct theme shape
type ThemeShape = Record<string, any>;

const useSurveyStyles = createSurveyStyles((theme: ThemeShape) => ({
  pageTitle: {
    color: theme?.titleColor,
    lineHeight: 1.25,
    ...theme?.pageTitle,
    // reset font weight changed by the theme above
    '& strong': {
      fontWeight: 'bold !important',
    },
  },
}));

export default useSurveyStyles;
